import { useTranslation } from "react-i18next";
import { balanceStatusStyle } from "../utils/balanceStatusStyle";
import { toMoney } from "../utils/toMoney";

export default function BalanceBoxes({
  notAlignedEnd,
  boxes,
  noStyle = "u-margin--top_400",
}) {
  const { t } = useTranslation("general");

  return (
    <div
      className={`${
        notAlignedEnd ? "" : "margin-inline"
      } ${noStyle} balances o-column o-column--vertical-align_end o-column--gap-size_400 `}
    >
      {boxes?.map((box, index) => (
        <p className="balance" key={index}>
          <span>{t(box?.title)}: </span>
          {box?.pureValue >= 0 ? (
            <span className={box?.pureValueStyles || "neutral-value"}>
              {toMoney(box?.pureValue)} {box?.currency || ""}
            </span>
          ) : (
            <span className={balanceStatusStyle(box?.value)}>
              {box?.value} {box?.currency || ""}
            </span>
          )}
        </p>
      ))}
    </div>
  );
}
